import { useState } from 'react';

import ProfileIcon from '~/assets/icons/Profile';
import SignUp from '~/components/Modals/Login/SignUpFlow';
import Tracked from '~/components/Tracked';
import RegisterIntentEvent from '~/events/RegisterIntentEvent';
import { useRegistrationStart } from '~/hooks/useRegistrationInteraction';
import useRootData from '~/hooks/useRootData';

const SIGNED_OUT_ICON_COLOUR = '#A9A9A9';

export default function ProfileSignInButton() {
  const [isOpen, setIsOpen] = useState(false);
  const { isBot } = useRootData();
  const recordRegistrationStart = useRegistrationStart();

  function openSignIn() {
    new RegisterIntentEvent({
      buttonName: 'PROFILE_ICON',
      isBot,
      pagePosition: 'Header'
    }).sendToGtm();
    recordRegistrationStart({ placement: 'header' });
    setIsOpen(true);
  }

  return (
    <>
      <Tracked.Button
        aria-label="Sign in"
        className="flex"
        name="Sign in"
        onClick={openSignIn}
        pagePosition="Header"
        type="button"
        variant="none"
      >
        <ProfileIcon color={SIGNED_OUT_ICON_COLOUR} />
      </Tracked.Button>
      {isOpen && (
        <SignUp
          modalType="account"
          onDismiss={() => setIsOpen(false)}
          postAuthOptions={{ action: 'redirect' }}
          registrationEntry={{ placement: 'header' }}
        />
      )}
    </>
  );
}
